/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUserTasksGetLastSelectedIdParameter } from './ApiUserTasksGetLastSelectedIdParameter';
import {
    ApiUserTasksGetLastSelectedIdParameterFromJSON,
    ApiUserTasksGetLastSelectedIdParameterFromJSONTyped,
    ApiUserTasksGetLastSelectedIdParameterToJSON,
    ApiUserTasksGetLastSelectedIdParameterToJSONTyped,
} from './ApiUserTasksGetLastSelectedIdParameter';

/**
 * 
 * @export
 * @interface UploadFileResponse
 */
export interface UploadFileResponse {
    /**
     * 
     * @type {ApiUserTasksGetLastSelectedIdParameter}
     * @memberof UploadFileResponse
     */
    mediaId: ApiUserTasksGetLastSelectedIdParameter;
    /**
     * 
     * @type {string}
     * @memberof UploadFileResponse
     */
    fileName: string;
    /**
     * 
     * @type {ApiUserTasksGetLastSelectedIdParameter}
     * @memberof UploadFileResponse
     */
    entryId: ApiUserTasksGetLastSelectedIdParameter;
    /**
     * 
     * @type {string}
     * @memberof UploadFileResponse
     */
    entryType: string;
    /**
     * 
     * @type {string}
     * @memberof UploadFileResponse
     */
    cdnUrl: string;
    /**
     * 
     * @type {string}
     * @memberof UploadFileResponse
     */
    url: string;
}

/**
 * Check if a given object implements the UploadFileResponse interface.
 */
export function instanceOfUploadFileResponse(value: object): value is UploadFileResponse {
    if (!('mediaId' in value) || value['mediaId'] === undefined) return false;
    if (!('fileName' in value) || value['fileName'] === undefined) return false;
    if (!('entryId' in value) || value['entryId'] === undefined) return false;
    if (!('entryType' in value) || value['entryType'] === undefined) return false;
    if (!('cdnUrl' in value) || value['cdnUrl'] === undefined) return false;
    if (!('url' in value) || value['url'] === undefined) return false;
    return true;
}

export function UploadFileResponseFromJSON(json: any): UploadFileResponse {
    return UploadFileResponseFromJSONTyped(json, false);
}

export function UploadFileResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UploadFileResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'mediaId': ApiUserTasksGetLastSelectedIdParameterFromJSON(json['mediaId']),
        'fileName': json['fileName'],
        'entryId': ApiUserTasksGetLastSelectedIdParameterFromJSON(json['entryId']),
        'entryType': json['entryType'],
        'cdnUrl': json['cdnUrl'],
        'url': json['url'],
    };
}

export function UploadFileResponseToJSON(json: any): UploadFileResponse {
    return UploadFileResponseToJSONTyped(json, false);
}

export function UploadFileResponseToJSONTyped(value?: UploadFileResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'mediaId': ApiUserTasksGetLastSelectedIdParameterToJSON(value['mediaId']),
        'fileName': value['fileName'],
        'entryId': ApiUserTasksGetLastSelectedIdParameterToJSON(value['entryId']),
        'entryType': value['entryType'],
        'cdnUrl': value['cdnUrl'],
        'url': value['url'],
    };
}

